// <shipping-estimate>: fills in the dispatch dates from today's date (min/max days, optionally skipping weekends)
// and the visitor's country and flag. Runs in the browser so a cached page always shows today's estimate.
// The country comes from Shopify's geolocation (the market country only covers stores with one market per country).
if (!customElements.get('shipping-estimate')) {
  customElements.define(
    'shipping-estimate',
    class ShippingEstimate extends HTMLElement {
      connectedCallback() {
        const { min, max, skipWeekends, country, text } = this.dataset;
        const format = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
          weekday: 'short',
          day: 'numeric',
          month: 'short',
        });
        const start = format.format(this.addDays(Number(min), skipWeekends === 'true'));
        const end = format.format(this.addDays(Number(max), skipWeekends === 'true'));

        // The dates are bold; the rest of the text stays as typed in the customizer
        const target = this.querySelector('[data-shipping-date]');
        target.replaceChildren(
          ...text.split(/(\[date\]|\[start\])/).map((part) => {
            if (part !== '[date]' && part !== '[start]') return document.createTextNode(part);
            const strong = document.createElement('strong');
            strong.textContent = part === '[date]' ? end : start;
            return strong;
          })
        );

        this.detectCountry(country);
      }

      // The country part stays hidden until the visitor's country is known, so it never flashes the market country
      async detectCountry(fallback) {
        let code = fallback;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}browsing_context_suggestions.json`);
          code = (await response.json()).detected_values?.country?.handle || fallback;
        } catch {
          // Keep the market country
        }
        this.setCountry(code);
        this.setAttribute('data-country-ready', '');
      }

      setCountry(code) {
        // Two-letter ISO code -> flag emoji (regional indicator letters)
        const flag = this.querySelector('[data-shipping-flag]');
        if (flag && /^[A-Z]{2}$/.test(code)) {
          flag.textContent = String.fromCodePoint(...[...code].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));
        }
        // Short code as in "Fast PK Shipping"; Britain reads as UK
        const label = this.querySelector('[data-shipping-country]');
        if (label && code) label.textContent = this.dataset.countryText.replace('[country]', code === 'GB' ? 'UK' : code);
      }

      addDays(days, skipWeekends) {
        const date = new Date();
        let added = 0;
        while (added < days) {
          date.setDate(date.getDate() + 1);
          if (!skipWeekends || (date.getDay() !== 0 && date.getDay() !== 6)) added++;
        }
        // A weekend start date rolls to Monday too
        while (skipWeekends && (date.getDay() === 0 || date.getDay() === 6)) date.setDate(date.getDate() + 1);
        return date;
      }
    }
  );
}
